import React from "react";
import { colors, spacing } from "./theme";

export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;

  return (
    <nav style={containerStyle} aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={`${item.label}-${index}`}>
            {item.href && !isLast ? (
              <a href={item.href} style={linkStyle}>
                {item.label}
              </a>
            ) : (
              <span style={isLast ? currentStyle : textStyle}>
                {item.label}
              </span>
            )}

            {!isLast && <span style={separatorStyle}>/</span>}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

const containerStyle = {
  display: "flex",
  alignItems: "center",
  gap: spacing.sm,
  marginBottom: spacing.lg,
  color: colors.textMuted,
  fontSize: 13,
  fontWeight: 600
};

const linkStyle = {
  color: colors.textMuted,
  textDecoration: "none"
};

const textStyle = {
  color: colors.textMuted
};

const currentStyle = {
  color: colors.text,
  fontWeight: 800
};

const separatorStyle = {
  color: colors.textSoft
};